// extracted by mini-css-extract-plugin
export default {"overlay":"loadingIndicator_overlay__To5av","indicator":"loadingIndicator_indicator__90dFD"};